import { useForm, useFormContext } from 'react-hook-form';

export const FORM_FIELDS = {
  FILE: 'file',
  DESCRIPTION: 'description',
  INDICATOR_NAME: 'indicatorName',
} as const;

export const FILE_UPLOAD_VALIDATION = {
  ACCEPTED_FILE_TYPES: ['.csv', '.xlsx', '.json'],
  MAX_FILE_SIZE_MB: 100,
} as const;

export type InSituFileUploadFormFieldValues = {
  [FORM_FIELDS.FILE]: File | string | null;
  [FORM_FIELDS.DESCRIPTION]: string;
  [FORM_FIELDS.INDICATOR_NAME]: string;
};

export const useInSituFileUploadForm = useForm<InSituFileUploadFormFieldValues>;
export const useInSituFileUploadContext = useFormContext<InSituFileUploadFormFieldValues>;
